import { FC } from 'react';

import { Flex } from 'antd';

import {
  DocumentExpenseForm,
  DocumentExpenseStatus,
  DocumentsStatusTag,
} from '@entities';

import { Schemas } from '@api-client/generated/types';

import * as S from './styled';

type DocumentExpenseCardProps = {
  document: Schemas.Document;
  onAfterUpdate: () => void;
  onPendingChange?: (pending: boolean) => void;
};

const DocumentExpenseCard: FC<DocumentExpenseCardProps> = ({
  document,
  onAfterUpdate,
  onPendingChange,
}) => {
  const isProcessing = document.adminStatus === 'processing';
  const isBooked = document.adminStatus === 'processed';

  return (
    <S.Card>
      {(isProcessing || isBooked) && (
        <DocumentExpenseStatus
          status={document.adminStatus}
          bobStatus={document.bobStatus}
          hasError={document.hasError}
          errorCode={document.errorCode}
          bobPendingAt={document.bobPendingAt}
        />
      )}

      <S.Inner gap={18} vertical>
        <Flex align="center" justify="space-between">
          <S.Title>Expense Details</S.Title>

          {!isBooked && !isProcessing && (
            <DocumentsStatusTag
              status={document.adminStatus}
              bobStatus={document.bobStatus}
              hasError={document.hasError}
              errorCode={document.errorCode}
              bobPendingAt={document.bobPendingAt}
            />
          )}
        </Flex>

        <DocumentExpenseForm
          document={document}
          onAfterUpdate={onAfterUpdate}
          onPendingChange={onPendingChange}
        />
      </S.Inner>
    </S.Card>
  );
};

export default DocumentExpenseCard;
